// active nav highlighting
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.collection-links__link');
  const currentPath = window.location.pathname;
  
  links.forEach(link => {
    const href = link.getAttribute('href');
    if (href && (href === currentPath || currentPath.startsWith(href))) {
      link.classList.add('active-collection-link');
    }
  });
});

// global pointer event block
(function() {
  document.querySelectorAll('*').forEach(el => {
    el.style.pointerEvents = 'none';
  });
  
  // release
  let released = false;

  document.addEventListener('mousemove', release, { once: true });
  document.addEventListener('touchstart', release, { once: true });
  document.addEventListener('scroll', release, { once: true });

  function release() {
    if (!released) {
      released = true;
      document.querySelectorAll('*').forEach(el => {
        el.style.pointerEvents = '';
      });
      document.documentElement.classList.add('pointer-ready');
    }
  }
})();

// Overlay Layout Shift Killer - fixed body + scrollbar padding
let scrollbarWidth = 0;

function measureScrollbar() {
  scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
}

measureScrollbar();

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    const target = mutation.target;
    
    if (target === document.body && target.style.position === 'fixed') {
      document.body.style.setProperty('width', `calc(100% - ${scrollbarWidth}px)`, 'important');
    }
    
    // overlay gone - restore
    if (target === document.body && target.style.position !== 'fixed') {
      document.body.style.setProperty('width', '100%', 'important');
    }
  });
});

observer.observe(document.body, { 
  attributes: true, 
  attributeFilter: ['style'] 
});

window.addEventListener('resize', () => {
  if (!document.body.style.position || document.body.style.position !== 'fixed') {
    measureScrollbar();
  }
});


//copy discount code on click as quick solution
function createDiscountCopyLink() {
  const couponLink = document.querySelector('.announcement-bar__text > a');

  if (couponLink) {
    const discountCode = couponLink.textContent.trim();

    couponLink.removeAttribute('title');
    couponLink.href = '#';

    couponLink.onclick = function(e) {
      e.preventDefault();
      navigator.clipboard.writeText(discountCode).then(() => {
        couponLink.textContent = 'Kopiert!';
        setTimeout(() => couponLink.textContent = discountCode, 2000);
      }).catch(err => {
        console.error('Fehler beim Kopieren:', err);
      });
    };
  }
}

createDiscountCopyLink();

// Zoom-Click-Hover
function addZoomClickHover() {
  const TRANSITION_SPEED = 300; // same as in CSS
  const MIN_WIDTH = 750;
  const ZOOM_OUT_DELAY = 1000;

  if (window.innerWidth < MIN_WIDTH) return;

  const imgContainers = document.querySelectorAll('main[data-template="product"] .product-media');
  if (imgContainers.length === 0) return;

  imgContainers.forEach(container => {
    const img = container.querySelector('.product-media__image');
    if (!img) return;

    let zoomOutTimeout;

    const getOffsets = (e) => {
      const rect = img.getBoundingClientRect();
      return {
        offsetX: (e.clientX - rect.left) / rect.width,
        offsetY: (e.clientY - rect.top) / rect.height
      };
    };

    const onMouseMove = (e) => {
      if (!img.classList.contains('zoomed')) return;

      const { offsetX, offsetY } = getOffsets(e);
      img.style.transformOrigin = `${offsetX * 100}% ${offsetY * 100}%`;
    };

    const handleZoomIn = (e) => {
      clearTimeout(zoomOutTimeout);
      const { offsetX, offsetY } = getOffsets(e);
      img.style.transformOrigin = `${offsetX * 100}% ${offsetY * 100}%`;
      img.classList.add('zoomed');
      container.addEventListener('mousemove', onMouseMove);
    };

    const handleZoomOut = () => {
      img.classList.remove('zoomed');
      container.removeEventListener('mousemove', onMouseMove);
      setTimeout(() => {
        img.style.transformOrigin = 'center center';
      }, TRANSITION_SPEED);
    };

    container.addEventListener('click', (e) => {
      if (img.classList.contains('zoomed')) {
        handleZoomOut();
      } else {
        handleZoomIn(e);
      }
    });

    container.addEventListener('mouseleave', () => {
      zoomOutTimeout = setTimeout(() => {
        if (!container.matches(':hover') && img.classList.contains('zoomed')) {
          handleZoomOut();
        }
      }, ZOOM_OUT_DELAY);
    });

    container.addEventListener('mouseenter', () => {
      clearTimeout(zoomOutTimeout);
    });
  });
}

addZoomClickHover();

// Inklusive Inlett Produktseite - improvise
function addInletInfo() {
  const h1 = document.querySelector('main[data-template="product"] h1');
  if (h1 && h1.textContent.includes("Dekokissen")) {
    const inletInfo = document.createElement('div');
    inletInfo.className = 'inlet-info';
    inletInfo.textContent = "Daunen-Inlett inklusive"
    
    h1.insertAdjacentElement('afterend', inletInfo);
  }
}

addInletInfo();
